import * as React from 'react';

const CalendarStatusChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M18.9 11.5h-2v-1h-10v7h4v2h-6v-13h2v-2h2v2h6v-2h2v2h2v5z" />
        <path
            fill="#007F8C"
            className="calendar-status-chunky_svg__eds-icon-fill--ui-blue"
            d="M16.9 12.5c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z"
        />
    </svg>
);

CalendarStatusChunkySvg.displayName = 'CalendarStatusChunkySvg';
export default CalendarStatusChunkySvg;
